import {
    CREATE_GENERAL_DC_DETAILS_FAILURE_DK,
    CREATE_GENERAL_DC_DETAILS_REQUEST_DK,
    CREATE_GENERAL_DC_DETAILS_SUCCESS_DK,
    CREATE_USER_FORM_GENERAL_DC_DETAILS_DK,
    DELETE_GENERAL_DC_DETAILS_FAILURE_DK,
    DELETE_GENERAL_DC_DETAILS_REQUEST_DK,
    DELETE_GENERAL_DC_DETAILS_SUCCESS_DK,
    FETCH_SINGLE_GENERAL_DC_DETAILS_FAILURE_DK,
    FETCH_SINGLE_GENERAL_DC_DETAILS_REQUEST_DK,
    FETCH_SINGLE_GENERAL_DC_DETAILS_SUCCESS_DK,
    FETCH_GENERAL_DC_DETAILS_FAILURE_DK,
    FETCH_GENERAL_DC_DETAILS_REQUEST_DK,
    FETCH_GENERAL_DC_DETAILS_SUCCESS_DK,
    GENERAL_DC_DETAILS_USERFORM_RESET_DK,
    UPDATE_GENERAL_DC_DETAILS_FAILURE_DK,
    UPDATE_GENERAL_DC_DETAILS_REQUEST_DK,
    UPDATE_GENERAL_DC_DETAILS_SUCCESS_DK,
    FETCH_GENERAL_DC_DETAILS_BY_ID_REQUEST_DK,
    FETCH_GENERAL_DC_DETAILS_BY_ID_SUCCESS_DK,
    FETCH_GENERAL_DC_DETAILS_WITHOUT_ID_SUCCESS_DK,
    FETCH_GENERAL_DC_DETAILS_GROUP_LIST_REQUEST_DK,
    FETCH_GENERAL_DC_DETAILS_GROUP_LIST_SUCCESS_DK,
    FETCH_GENERAL_DC_PREVIOUS_LIST_REQUEST_DK,
    FETCH_GENERAL_DC_PREVIOUS_LIST_FAILURE_DK,
    FETCH_GENERAL_DC_PREVIOUS_LIST_SUCCESS_DK,
} from './generalDCDetails.actionsType';

export const GENERAL_DC_DETAILS_DK = 'generalDCDetailsDK';

let initialState = {
    loading: false,
    generalDCDetailsById: [],
    generalDCDetails: [],
    generalDCDetailsWithoutId:[],
    groupList: [],
    userform: {
        fldRatePerKG: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0
    },
    previousList: [],
    //selectedKnittingDCDetails: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let generalDCDKDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_GENERAL_DC_DETAILS_REQUEST_DK:
        case FETCH_GENERAL_DC_DETAILS_GROUP_LIST_REQUEST_DK:
        case FETCH_GENERAL_DC_DETAILS_BY_ID_REQUEST_DK:
        case CREATE_GENERAL_DC_DETAILS_REQUEST_DK:
        case FETCH_SINGLE_GENERAL_DC_DETAILS_REQUEST_DK:
        case UPDATE_GENERAL_DC_DETAILS_REQUEST_DK:
        case DELETE_GENERAL_DC_DETAILS_REQUEST_DK:
        case FETCH_GENERAL_DC_PREVIOUS_LIST_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_GENERAL_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generalDCDetails: updatePayload
            };
        case FETCH_GENERAL_DC_DETAILS_BY_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generalDCDetailsById: updatePayload
            };
            case FETCH_GENERAL_DC_PREVIOUS_LIST_SUCCESS_DK:
                return {
                    ...state,
                    loading: false,
                    previousList: updatePayload
                };
            case FETCH_GENERAL_DC_DETAILS_GROUP_LIST_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                groupList: updatePayload
            };
            case FETCH_GENERAL_DC_DETAILS_WITHOUT_ID_SUCCESS_DK:
                return {
                    ...state,
                    loading: false,
                    generalDCDetailsWithoutId: updatePayload
                };
        case CREATE_GENERAL_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldRatePerKG: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case FETCH_SINGLE_GENERAL_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: updatePayload
            };
        case UPDATE_GENERAL_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
              //  selectedKnittingDCDetails: {},
                userform: {
                    fldRatePerKG: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case DELETE_GENERAL_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldRatePerKG: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
                //,  selectedKnittingDCDetails: {}
            };

        case FETCH_GENERAL_DC_DETAILS_FAILURE_DK:
        case FETCH_GENERAL_DC_PREVIOUS_LIST_FAILURE_DK:
        case FETCH_SINGLE_GENERAL_DC_DETAILS_FAILURE_DK:
        case CREATE_GENERAL_DC_DETAILS_FAILURE_DK:
        case UPDATE_GENERAL_DC_DETAILS_FAILURE_DK:
        case DELETE_GENERAL_DC_DETAILS_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_GENERAL_DC_DETAILS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case GENERAL_DC_DETAILS_USERFORM_RESET_DK:
            return {
                ...state,
                userform: {
                    fldRatePerKG: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
                //,  selectedKnittingDCDetails: {}
            };
        default:
            return state;
    }
};
